// src/app/routing/rootRoute.tsx
import { createRootRoute, Outlet, redirect } from '@tanstack/react-router';
import AuthLayout from '@/common/layouts/AuthLayout';
import ProtectedLayout from '@/common/layouts/ProtectedLayout';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { useAuthStore } from '@/features/auth/store/authStore';
import { useEffect } from 'react'; // Import useEffect
import GlobalHealthLoadingOverlay from '@/common/components/GlobalHealthLoadingOverlay';


// Define the root route component
function RootRouteComponent() {
  // ✅ Correctly subscribe to the isAuthenticated state from the store
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const hasHydrated = useAuthStore((state) => state.hasHydrated);
 // const token = useAuthStore((state) => state.token); // Also listen to token changes if needed for debugging

  // Optional: Log state changes for debugging
  useEffect(() => {
    // console.log('RootRouteComponent isAuthenticated state changed:', isAuthenticated);
  }, [isAuthenticated]);


  if (!hasHydrated) {
    return null;
  }

  return (
    <>
      {!isAuthenticated ? (
        <AuthLayout>
          <Outlet />
        </AuthLayout>
      ) : (
        <ProtectedLayout>
          <Outlet />
        </ProtectedLayout>
      )}
      <GlobalHealthLoadingOverlay />
      {import.meta.env.DEV && <TanStackRouterDevtools initialIsOpen={false} />}
    </>
  );
}

// Create the root route
export const rootRoute = createRootRoute({
  component: RootRouteComponent,
  // Use beforeLoad for authentication checks and redirects
  beforeLoad: ({ location }) => {
    const isAuthenticated = useAuthStore.getState().isAuthenticated();
    const hasHydrated = useAuthStore.getState().hasHydrated;

    if (!hasHydrated) {
      return;
    }

    // If the user is not authenticated AND they are trying to access a protected route
    // (i.e., not already on an auth-related path like /auth/login or /auth/register)
    // then redirect them to the login page.
    if (!isAuthenticated && !location.pathname.startsWith('/auth')) {
      throw redirect({ to: '/auth/login' });
    }
    // If the user *is* authenticated and they are trying to access an auth path (e.g., /auth/login),
    // redirect them to a protected default route (e.g., /dashboard).
    if (isAuthenticated && location.pathname.startsWith('/auth')) {
      throw redirect({ to: '/dashboard' }); // Or your desired authenticated landing page
    }
  },
  // Add an error component if desired
  // errorComponent: () => <div>Something went wrong!</div>,
});